var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18.584a8.62 8.62 0 016.023-2.463c2.308 0 4.408.919 5.977 2.416A8.62 8.62 0 0111.977 21C9.669 21 7.569 20.081 6 18.584zM3.975 16.025A8.93 8.93 0 013 12c0-4.974 4.026-9 9-9s9 4.026 9 9c0 1.45-.363 2.81-.977 4.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.121 7.879A3 3 0 119.88 12.12 3 3 0 0114.12 7.88"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgUser1;


//////////////////
// WEBPACK FOOTER
// ./src/icons/user1.svg
// module id = 811
// module chunks = 13